import { StorageKey } from '../../lib/storageKeys';

/**
 * Ids of the parent projects the user collapsed in the quick-mark card, kept on this device
 * (data dictionary §7, `wiztime.quickMarkCollapsed`). The set holds the *collapsed* ones, so a
 * parent that is new, or was never touched, is expanded. Unreadable or malformed content reads as empty.
 */
export function readCollapsedParents(): ReadonlySet<string> {
  try {
    const raw = localStorage.getItem(StorageKey.QuickMarkCollapsed);
    if (raw === null) return new Set();
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((entry): entry is string => typeof entry === 'string'));
  } catch {
    return new Set();
  }
}

/** Stores the set; a storage failure (private window, blocked site data) only loses the memory. */
export function writeCollapsedParents(collapsed: ReadonlySet<string>): void {
  try {
    if (collapsed.size === 0) localStorage.removeItem(StorageKey.QuickMarkCollapsed);
    else localStorage.setItem(StorageKey.QuickMarkCollapsed, JSON.stringify([...collapsed]));
  } catch {
    // The state still works for this page view.
  }
}
